module.exports = __webpack_public_path__ + "img/bg-swzl.ab9ac99a.png";